let kids_data = [
    {
        type: '키즈',
        name: 'FILA KIDS X HIRO 레이싱 리버서블자켓',
        price: '135,000원',
        imgUrl: '/img/kids1.jpg'
    },
    {
        type: '키즈',
        name: 'FILA KIDS X HIRO 레이싱 리버서블자켓',
        price: '135,000원',
        imgUrl: '/img/kids2.jpg'
    },
    {
        type: '키즈',
        name: 'FILA KIDS X HIRO 블레이드 KD',
        price: '79,000원',
        imgUrl: '/img/kids3.jpg'
    },
    {
        type: '키즈',
        name: 'FILA KIDS X HIRO 보더 스웨이드 KD',
        price: '59,000원',
        imgUrl: '/img/kids4.jpg'
    },
    {
        type: '키즈',
        name: 'FILA KIDS X HIRO 보더 스웨이드 KD',
        price: '59,000원',
        imgUrl: '/img/kids5.jpg'
    },
    {
        type: '키즈',
        name: 'FILA KIDS X HIRO 더블로고 티셔츠',
        price: '38,000원',
        imgUrl: '/img/kids6.jpg'
    },
    {
        type: '키즈',
        name: 'FILA KIDS X HIRO 더블로고 티셔츠',
        price: '38,000원',
        imgUrl: '/img/kids7.jpg'
    },
    {
        type: '키즈',
        name: 'FILA KIDS X HIRO 레이싱 모티브 스웨트',
        price: '59,000원',
        imgUrl: '/img/kids8.jpg'
    },
    {
        type: '키즈',
        name: 'FILA KIDS X HIRO 레이싱 모티브 조거팬츠',
        price: '55,000원',
        imgUrl: '/img/kids9.jpg'
    }
]


export default kids_data;